export enum EnumMenu {
  LEITOR = 1000,
  HISTORICO = 1001,
  CONFIGURACOES = 1002,

  MASTER_SAIR = 99999,
}
